/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplatesControllerFindAllQueryResponse, WorkflowTemplatesControllerFindAllQueryParams, WorkflowTemplatesControllerFindAll401, WorkflowTemplatesControllerFindAll403 } from "../../models/workflowsController/WorkflowTemplatesControllerFindAll";

function getWorkflowTemplatesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/workflow-templates` as const }  
  return res
}

/**
 * @summary List workflow templates (scope-filtered)
 * {@link /api/v1/workflow-templates}
 */
export async function workflowTemplatesControllerFindAll(params?: WorkflowTemplatesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowTemplatesControllerFindAllQueryResponse, ResponseErrorConfig<WorkflowTemplatesControllerFindAll401 | WorkflowTemplatesControllerFindAll403>, unknown>({ method : "GET", url : getWorkflowTemplatesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}